import { IconButton, InputAdornment, TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useState } from "react";

function PasswordField({ label, value, onChange, className, fullWidth, sx, variant = 'outlined' }) {
    const [show, setShow] = useState(false);

    return (
        <TextField
            type={show ? "text" : "password"}
            label={label}
            value={value}
            onChange={onChange}
            className={className}
            fullWidth={fullWidth}
            variant={variant}
            sx={sx}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={() => setShow(!show)} edge="end" tabIndex={-1}>
                                {show ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
}

export default PasswordField;
